var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickdet03(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99668 18.3275C14.5976 18.3275 18.3273 14.5977 18.3273 9.9968C18.3273 5.3959 14.5976 1.66614 9.99668 1.66614C5.39578 1.66614 1.66602 5.3959 1.66602 9.9968C1.66602 14.5977 5.39578 18.3275 9.99668 18.3275Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99683 4.99841V9.99681L13.3291 11.6629",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9936,
    height: 19.9936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickdet03);
export default __webpack_public_path__ + "static/media/tickdet03.e12042681458dad419568d5cd970a380.svg";
export { ForwardRef as ReactComponent };